 <template>
  <div class="app-gdpr-data-wrapper">
    <ShowGDPRData >
      <template #txtHeadline><slot name="txtHeadline"></slot></template>
      <template #txtBeforeContent><slot name="txtBeforeContent"></slot></template>
      <template #btnNext><slot name="btnNext"></slot></template>
    </ShowGDPRData>
  </div>
</template>

<script>
import ShowGDPRData from './ShowGDPRData.vue'
import transaction from '@/mixins/transaction'

export default {
  name: 'GDPRDataWrapper',
  mixins: [
    transaction('GDPRData')
  ],
  components: {
    ShowGDPRData
  }
}
</script>
